/**
 * Grid del modal, si algun dia se actualiza este proyecto debemos refactorizar el componente DHX y la implementacion
 */

import React from "react";
import GridDHX from "./GridDHX";
import Loader from "../../../globals/Loader";
function ConsignacionesGrid(props){

  const {
    data,
    ready
  } = props;

  const columns = [
    
    { 
      id: 'upc', 
      header: [
        { align:'left',text: 'UPC' },
        
      ],
      footer:[
        { align:'left',text: 'Total de elementos: '+data.length, colspan:2 },
      ],
      align:'left',
    
      width:120,

    },
    { 
      id: 'fecha_compra_efectiva', 
      header: [
        { align:'left',text: 'Fecha Compra <br> Efectiva' },
        
      ],
      align:'left',
      enableHtml:true,
      width:150,
      
    },
    { 
      id: 'nombre', 
      header: [
        { align:'left',text: 'Producto' },
        
      ],
      align:'left',
      enableHtml:true,
      minWidth:150,
      autoWidth:true
    },
    { 
      id: 'plataforma', 
      header: [
        { align:'center',text: 'Plataforma' },
        
      ],
      align:'center',
      enableHtml:true,
      width:80,
    },
    { 
      id: 'unidades_consignacion_iniciales', 
      header: [
        { align:'left',text: 'Unidades Consignadas <br> Iniciales' },
        
      ],
      footer:[
        { align:'right',content: 'sum' },
      ],
      align:'right',
      enableHtml:true,
      autoWidth:true,
      width:150,
      format:'#,#', 
    },
    { 
      id: 'pendientes', 
      header: [
        { align:'left',text: 'Pendientes' },
        
      ],
      footer:[
        { align:'right',content: 'sum' },
      ],
      align:'right',
      enableHtml:true,
      width:130,
      format:'#,#', 

    },
    { 
      id: 'venta_unidades_calculado', 
      header: [
        { align:'left',text: 'Unidades Vendidas' },
        
      ],
      footer:[
        { align:'right',content: 'sum' },
      ],
      align:'right',
      enableHtml:true,
      width:130,
      format:'#,#', 

    },
    { 
      id: 'devueltos', 
      header: [
        { align:'left',text: 'Devueltos' },
        
      ],
      footer:[
        { align:'right',content: 'sum' },
      ],
      align:'right',
      enableHtml:true,
      width:130,
      format:'#,#', 

    },
    { 
      id: 'defectuosos', 
      header: [
        { align:'left',text: 'Defectuosos' },
        
      ],
      footer:[
        { align:'right',content: 'sum' },
      ],
      align:'right',
      enableHtml:true,
      width:130,
      format:'#,#', 

    },
    { 
      id: 'perdidas', 
      header: [
        { align:'left',text: 'Perdidas' },
        
      ],
      footer:[
        { align:'right',content: 'sum' },
      ],
      align:'right',
      enableHtml:true,
      width:130,
      format:'#,#', 

    },
    { 
      id: 'compra_anticipada', 
      header: [
        { align:'left',text: 'Compra Anticipada' },
        
      ],
      footer:[
        { align:'right',content: 'sum' },
      ],
      align:'right',
      enableHtml:true,
      width:130,
      format:'#,#', 

    },
   
  ];


  if(ready){
    return (
      <div style={{height:'100%',width:'100%'}}>
        
        <GridDHX
           columns={columns}
           data={data}
        />
      </div>
    );
  }
  else{
    <Loader/>
  }
  
}
export default ConsignacionesGrid;